<template>
  <v-card>
    <v-card-title>バリデーション条件</v-card-title>
    <v-card-text>
      <v-container>
        <v-row class="ma-1">特定状態でバリデーションをスキップする</v-row>
        <v-row class="ma-1"> rules:{{ rules }}</v-row>
        <v-row class="ma-1"> value:{{ value }}</v-row>
        <v-row>
          <v-col cols="4">
            <v-text-field
              label="ラベル名(使わない)"
              v-model="returnData.label"
              :rules="[varidation.required]"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <hr />
        <!-------------- ------------>
        {{ joinTerms }}
        *{}で囲むとX文字列を含む場合 *notNull で対象フォームIDが空でない時
        *isNull で対象フォームIDの時
        <div v-for="(term, i) in joinTerms" :key="`1-${i}`" class="mb-4">
          <v-row>
            <v-col cols="2">
              <div v-if="i != 0">
                <v-select
                  :items="joinTerm"
                  v-model="joinTerms[i]"
                  label="AND OR"
                  :rules="[varidation.required]"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="selectclickTerms"
                v-model="clickTerms[i]"
                label="条件"
                item-text="label"
                item-value="value"
                :rules="[varidation.required]"
              ></v-select>
            </v-col>
            <v-col cols="2" v-if="clickTerms[i] == 'role'">
              <v-select
                label="権限レベル"
                :rules="[]"
                v-model="clickTermValues[i]"
                item-text="label"
                item-value="value"
                :items="selectRole"
              ></v-select>
            </v-col>
            <v-col
              cols="2"
              v-else-if="
                clickTerms[i] == 'formID' || clickTerms[i] == 'UserformID'
              "
            >
              <v-text-field
                label="条件対象formID"
                :rules="[varidation.numonly]"
                v-model="clickTermValues[i]"
                required
              ></v-text-field>
            </v-col>
            <v-col
              cols="3"
              v-if="clickTerms[i] == 'formID' || clickTerms[i] == 'UserformID'"
            >
              <v-text-field
                label="if == X"
                :rules="[]"
                v-model="clickTermCondition[i]"
                required
              ></v-text-field>
              *先頭に!で !=
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="1">
            <v-btn @click="add1" class="ma-2">追加</v-btn>
          </v-col>
          <v-col cols="1">
            <v-btn @click="del1" class="ma-2">削除</v-btn>
          </v-col>
        </v-row>
        <!-------------------------------------->
        <v-row>
          <v-col>
            <v-checkbox
              v-model="originalValidationFlag"
              label="オリジナルバリデーション"
              value="required"
              @click="setTargetRules"
            ></v-checkbox>
            再チェックで初期化
          </v-col>
        </v-row>
        <v-row v-if="originalValidationFlag">
          <div v-for="(target, i) in targetRules" :key="`1-${i}`" class="ma-1">
            <v-col cols="0">
              <v-card elevation="2">
                <v-text-field
                  class="ma-1"
                  label="ラベル名"
                  :rules="[]"
                  v-model="target.Label"
                  disabled
                ></v-text-field>
                <v-select
                  class="ma-1"
                  :items="validationRules"
                  item-text="text"
                  item-value="value"
                  v-model="target.validation"
                  label="バリデーションルール"
                ></v-select>
                <v-btn @click="del2(i)" class="ma-1" color="red">削除</v-btn>
              </v-card>
            </v-col>
          </div>
        </v-row>
        <!--------------------------------- -->
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="submit">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");
export default {
  props: {
    label: String,
    type: Number,
    cols: Number,
    position: Number,
    //個別値
    value: String,
    rule: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        cols: this.cols,
        position: this.position,
        //個別値
        value: this.value,
        rule: this.rule,
      },
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
        required: (value) => !!value || "必須項目です",
      },
      //個別値
      rules: [],
      joinTerms: [],
      clickTerms: [],
      clickTermValues: [],
      clickTermCondition: [],
      //
      joinTerm: ["AND", "OR", "AND(", "OR(", "AND)", "OR)"],
      selectclickTerms: [
        { label: "ユーザ権限", value: "role" },
        { label: "特定フォーム値", value: "formID" },
        { label: "ユーザ情報の特定フォーム値", value: "UserformID" },
      ],
      selectRole: [
        { label: "一般", value: "0" },
        { label: "管理者", value: "1" },
        { label: "第3属性", value: "2" },
      ],
      //
      originalValidationFlag: false,
      targetRules: [],
      validationRules: this.$store.state.validationRules.concat(),
    };
  },
  mounted() {
    console.log(
      "this.$store.state.validatationRules",
      this.$store.state.validatationRules
    );
    if (this.rule != "" && typeof this.rule != "undefined") {
      this.rules = this.rule.split(",");
    }
    if (this.rules.length > 3 && this.rules[2] != "") {
      this.joinTerms = this.rules[1].split(":");
      this.clickTerms = this.rules[2].split(":");
      this.clickTermValues = this.rules[3].split(":");
      this.clickTermCondition = this.rules[4].split(":");
    }
    if (this.returnData.value != "") {
      this.originalValidationFlag = "required";
      this.targetRules = JSON.parse(this.returnData.value);
    }
  },
  methods: {
    submit() {
      this.rules[1] = this.joinTerms.join(":");
      this.rules[2] = this.clickTerms.join(":");
      this.rules[3] = this.clickTermValues.join(":");
      this.rules[4] = this.clickTermCondition.join(":");
      if (this.rules[5] == null) {
        this.rules[6] == "";
      }
      this.returnData.rule = this.rules.join(",");
      //
      if (this.originalValidationFlag) {
        this.returnData.value = JSON.stringify(this.targetRules);
      } else {
        this.returnData.value = "";
      }
      //
      this.$emit("clickSubmit", this.returnData);
    },
    add1() {
      let i = this.joinTerms.length - 1;
      this.joinTerms.push(this.joinTerms[i]);
      this.clickTerms.push(this.clickTerms[i]);
      this.clickTermValues.push(this.clickTermValues[i]);
      this.clickTermCondition.push(this.clickTermCondition[i]);
    },
    del1() {
      if (this.joinTerms.length > 0) {
        this.joinTerms.splice(-1, 1);
        this.clickTerms.splice(-1, 1);
        this.clickTermValues.splice(-1, 1);
        this.clickTermCondition.splice(-1, 1);
      }
    },
    //
    async setTargetRules() {
      if (this.originalValidationFlag) {
        let data = {
          pageID: Number(this.$route.params.page_id),
          area: [[]],
        };
        const response = await api.GetForm(data);
        //targetRules
        let arr = [];
        response.data[0].forEach((row, i) => {
          const col = response.data.map((item) => {
            return {
              ID: item[i].ID,
              Label: item[i].Label,
              validation: "",
            };
          });
          arr = arr.concat(col);
        });
        this.targetRules = arr.filter((a) => a.ID != 0);
      }
    },
    del2(index) {
      this.targetRules.splice(index, 1);
    },
  },
};
</script>
